0<!--
	作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面_跟地图操作有关的组件
-->
<template>
	<!--车辆监控页面_左栏按钮组开始-->
	<div class="btn-group-vertical menu-bar-vertical left_act_ctrl" :class="{'activ_magnify':magnify,'midSizeL':leftSize==1,'maxSizeL':leftSize==2,'minSizeL':leftSize==0}"  role="group" aria-label="...">
		<button type="button" class="btn btn-primary menu-button-vertical left_act_btn" id="tool1" :class="[rollUp?'downArrow':'upArrow']" @click="toggleMenu" data-toggle="menutip" data-placement="right" title="折叠"></button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===0 ?'active':'btn-white']" @click.stop.prevent="trafficMode($event,0)">
		  	<span>
		  		<img src="../../../assets/project/images/map/text_icon_11.png" width="36" height="36" alt=""/>
		  	</span>
		  	<!--<em>路况</em>-->
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===1 ?'active':'btn-white']" @click.stop.prevent="satellite($event,1)">
		  	<span><img src="../../../assets/project/images/map/text_icon_12.png" width="36" height="36" alt=""/></span>
		  	<!--<em>卫星</em>-->
		</button>
		<!--<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===11 ?'active':'btn-white']" @click.stop.prevent="srchVehicle($event,11)">
	  		<span><img src="../../../assets/project/images/map/text_icon_1c.png" width="36" height="36" alt=""/></span>
	  		
		</button>-->
		<button v-if="permission.indexOf('monitorVehicle_fence') == -1" style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===2 ?'active':'btn-white']" @click.stop.prevent="fence($event,2)">
	  		<span><img src="../../../assets/project/images/map/text_icon_13.png" width="36" height="36" alt=""/></span>
	  		<!--<em>围栏</em>-->
		</button>
		<button v-if="permission.indexOf('monitorVehicle_route') == -1" style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===3 ?'active':'btn-white']" @click.stop.prevent="route($event,3)">
	  		<span><img src="../../../assets/project/images/map/text_icon_14.png" width="36" height="36" alt=""/></span>
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===4 ?'active':'btn-white']" @click.stop.prevent="measure($event,4)">
	  		<span><img src="../../../assets/project/images/map/text_icon_15.png" width="36" height="36" alt=""/></span>
		</button>
		<button v-if="permission.indexOf('monitorVehicle_annotate') == -1" style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===5 ?'active':'btn-white']" @click.stop.prevent="addMarkers($event,5)">
	  		<span><img src="../../../assets/project/images/map/text_icon_16.png" width="36" height="36" alt=""/></span>
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===6 ?'active':'btn-white']" @click.stop.prevent="routePlan($event,6)">
	  		<span><img src="../../../assets/project/images/map/text_icon_17.png" width="36" height="36" alt=""/></span>
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===7 ?'active':'btn-white']" @click.stop.prevent="changeInfoBox($event,7)">
	  		<span><img src="../../../assets/project/images/map/text_icon_18.png" width="36" height="36" alt=""/></span>
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===8 ?'active':'btn-white']" @click.stop.prevent="clearCarMarkers($event,8)">
	  		<span><img src="../../../assets/project/images/map/text_icon_19.png" width="36" height="36" alt=""/></span>
		</button>
		<button style="outline:none;border:none;" type="button" class="btn" :class="[currentMenu===9 ?'active':'btn-white']" @click.stop.prevent="saveStyle($event,9)">
	  		<span><img src="../../../assets/project/images/map/text_icon_1a.png" width="36" height="36" alt=""/></span>
		</button>
	</div>
	<!--车辆监控页面_左栏按钮组结束-->
</template>
<script>
	import {
		mapState
	} from 'vuex'

	export default {
		name: 'MenuMap',
		data() {
			return {
				permission:this.$store.state.permission.permission["monitorVehicle"]?this.$store.state.permission.permission["monitorVehicle"]:[], 
				rollUp:false
			}
		},
		props:['currentMenu'],
		computed: mapState({
			magnify:state=>state.monitor.magnify, //面板处于缩小状态，可以点击放大
			leftSize:state=>state.monitor.leftSize
		}), 
		mounted(){
			this.$nextTick(function () {
				  $('[data-toggle="menutip"]').tooltip()
				})
		},
		destroyed(){
			$('[data-toggle="menutip"]').tooltip('hide')
		},
		methods: {
			toggleMenu() {
				this.rollUp = !this.rollUp;
				$(".btn-group-vertical .btn-white").slideToggle(300);
			},
			trafficMode(){
				this.$emit('trafficMode')
			},
			satellite(){
				this.$emit('satellite')
			},
			srchVehicle(){
				this.$emit('srchVehicle')
			},
			fence(){
				this.$emit('fence')
			},
			route(){
				this.$emit('route')
			},
			measure(){
				this.$emit('measure')
			},
			addMarkers(){
				this.$emit('addMarkers')
			},
			routePlan(){
				this.$emit('routePlan')
			},
			changeInfoBox(){//点击选择infoWindow显示模式
				this.$emit('changeInfoBox')
			},
			clearCarMarkers(){//点击清除地图上所有的车辆定位点图标
				this.$emit('clearCarMarkers')
			},
			saveStyle(){//保存界面风格
				this.$emit('saveStyle',9)
				this.$store.dispatch('savePageStyle',0) 
			}

		}

	}
</script>

<style scoped>
input:focus,select:focus,option:focus,textarea:focus,button:focus{outline: none;-webkit-highlight: none;}
img:focus{border:0;outline:none;}
input:active,select:active,option:active,textarea:active,button:active{outline: none;border:none;}
</style>


// WEBPACK FOOTER //
// MenuMap.vue?56ef8021